import { Box, FormControl, MenuItem, Select, useTheme } from "@mui/material"
import { useTranslation } from 'react-i18next';
import { getAssetImagesUrl } from "../../api/ApiDataHelper";

export default function ChangeLocale() {

  const theme = useTheme();

  const { i18n } = useTranslation();

  const lngs = {
    en: {
      nativeName: 'eng' ,
      img: "en.png"
    },
    it: {
      nativeName: 'ita',
      img: "it.png"
     }
  };

  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  const menuProps = {
    PaperProps: {
      style: {
        marginTop: "8px",
        backgroundColor: theme.palette.grey.light,  // Background color of the Menu
        backdropFilter: 'blur(10px)', // Adds a blur effect to the menu
        borderRadius: '24px',          // Rounded corners
      },
    },
    MenuListProps: {
      style: {
        padding: "8px", // Remove padding
      },
    },
  };

  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      // width:"100%"
    }}>
      {/* <Typography variant="body1">
        {t("label_language")}
      </Typography> */}
      {/* {Object.keys(lngs).map((lng) => (
        <Typography
          key={"lang_" + lng}
          onClick={() => { i18n.changeLanguage(lng) }}
          sx={{
            color: i18n.resolvedLanguage !== lng ? theme.palette.text.disabled : theme.palette.text.primary,
            cursor: i18n.resolvedLanguage !== lng ? "pointer" : "default"
          }}>{lngs[lng].nativeName}</Typography>
      ))} */}
      <FormControl sx={{
        }} size="small">
        <Select
          sx={{
            borderRadius:"24px",
            "& .MuiSelect-select": {

              display: "flex",
              alignItems: "center",
            }
          }}
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={i18n.resolvedLanguage}
          label=""
          onChange={handleChange}
          MenuProps={menuProps}
        >
          {Object.keys(lngs).map((lng) => (
            <MenuItem
              key={"lang_" + lng}
              value={lng}
              sx={{
                borderRadius:"24px",
                // color: i18n.resolvedLanguage !== lng ? theme.palette.text.disabled : theme.palette.text.primary,
                cursor: i18n.resolvedLanguage !== lng ? "pointer" : "default",
                background: i18n.resolvedLanguage !== lng ? "transparent" : theme.palette.background.paper + "66 !important",
                border: "1px solid " + (i18n.resolvedLanguage !== lng ? "transparent" : theme.palette.primary.main),
                p: 1,
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <img src={getAssetImagesUrl(lngs[lng].img)} alt={"flag " + lngs[lng].nativeName} style={{width:"20px", height:"20px",}} />
                {/* {lngs[lng].nativeName} */}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
